import React, { useMemo } from "react";
import Dialog from "../../../components/Dialog";
import { useAppDispatch } from "../../../hooks/reduxHook";
import useToast from "../../../hooks/useToast";
import { fetchPlayerTroop } from "../../../redux/pages/barracks/barracksActions";
import Network from "../../../utils/Network";
import { useBarracksUIContext } from "../BarracksContext";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const SellDialog = () => {
  const openToast = useToast();
  const axios = new Network();
  const { t } = useAppTranslation(["barracks"]);

  const dispatch = useAppDispatch();

  const barracksContext = useBarracksUIContext();
  const barracksUIProps = useMemo(() => {
    return {
      upgradeLoading: barracksContext?.upgradeLoading,
      setUpgradeLoading: barracksContext?.setUpgradeLoading,
      sellDialog: barracksContext?.sellDialog,
      setSellDialog: barracksContext?.setSellDialog,
    };
  }, [
    barracksContext?.upgradeLoading,
    barracksContext?.setUpgradeLoading,
    barracksContext?.sellDialog,
    barracksContext?.setSellDialog,
  ]);

  async function handleSellTroop() {
    barracksUIProps?.setUpgradeLoading?.(true);
    const response = await axios.CallApi({
      url: "/market/my-orders",
      body: {
        itemType: 3,
        itemId: barracksUIProps?.sellDialog?.item?.id,
        clegPrice: barracksUIProps?.sellDialog?.sellPrice,
        quantity: 1,
        orderType: 2,
      },
    });
    openToast(response);
    if (response.ok) {
      barracksUIProps?.setSellDialog?.((prev) => ({
        ...prev,
        open: false,
      }));
      dispatch(fetchPlayerTroop(50));
    }
    barracksUIProps?.setUpgradeLoading?.(false);
  }

  return (
    <Dialog
      loading={barracksUIProps?.upgradeLoading}
      onSubmit={handleSellTroop}
      title={t("barracks:dialogs.sell.title")}
      open={!!barracksUIProps?.sellDialog?.open}
      onClose={() =>
        barracksUIProps?.setSellDialog?.((prev) => ({ ...prev, open: false }))
      }
    >
      <div className="p-relative" style={{ zIndex: 200 }}>
        <p className="dark-yellow">{t("barracks:dialogs.sell.price")}</p>
        <input
          onKeyDown={(event) => {
            if (!/^[0-9.]$/.test(event.key)) {
              event.preventDefault();
            }
          }}
          onChange={(e) =>
            barracksUIProps?.setSellDialog?.((prev) => ({
              ...prev,
              sellPrice: e.target.value,
            }))
          }
          placeholder={t("barracks:dialogs.sell.placeholder")}
          type="text"
          style={{ marginBottom: -25 }}
          className="w-100 form-control form-input dark-yellow"
        />
      </div>
    </Dialog>
  );
};

export default SellDialog;
